import styled from "styled-components";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import SubscriptionsOutlinedIcon from "@mui/icons-material/SubscriptionsOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import SettingsBrightnessOutlinedIcon from "@mui/icons-material/SettingsBrightnessOutlined";
import { Link } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";

const Container = styled.div`
  padding: 10px 15px;
  width: 150px;
  height: max-content;
  position: fixed;
  top: 5px;
  right: 125px;
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.soft};
  background-color: ${({ theme }) => theme.bgLighter};
  color: ${({ theme }) => theme.text};
  z-index: 9999;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const Item = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.soft};
  }
`;
const Hr = styled.hr`
  margin: 15px 0px;
  border: 0.5px solid ${({ theme }) => theme.soft};
`;
const Login = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const Button = styled.button`
  padding: 5px 15px;
  background-color: transparent;
  border: 1px solid #3ea6ff;
  color: #3ea6ff;
  border-radius: 3px;
  font-weight: 500;
  margin-top: 10px;
  cursor: pointer;
  align-items: center;
  display: flex;
  gap: 5px;
`;

const SmMenu = ({
  openSmMenu,
  setOpenSmMenu,
  currentUser,
  darkMode,
  setDarkMode,
}) => {
  return (
    <>
      <Container>
        <Wrapper>
          <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
          <Item onClick={() => setOpenSmMenu(false)}>
              <HomeIcon />
              Home
            </Item>
          </Link>
          <Link
            to="/trend"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item onClick={() => setOpenSmMenu(false)}>
              <ExploreOutlinedIcon />
              Explore
            </Item>
          </Link>
          <Link
            to="/sub"
            style={{
              textDecoration: currentUser ? "none" : "none",
              color: currentUser ? "inherit" : "inherit",
            }}

          >
            <Item
              style={{
                cursor: currentUser ? "pointer" : "not-allowed",
              }}
              onClick={() => setOpenSmMenu(false)}
            >
              <SubscriptionsOutlinedIcon />
              Subscriptions
            </Item>
          </Link>
          <Hr />

          {!currentUser && (
            <>
              <Login>
                Sign in to like videos, comment, and subscribe.
                <Link to="signin" style={{ textDecoration: "none" }}>
                  <Button>
                    <AccountCircleOutlinedIcon />
                    SIGN IN
                  </Button>
                </Link>
              </Login>
              <Hr />
            </>
          )}
           <Item
            onClick={() => {
              setDarkMode(!darkMode);
              setOpenSmMenu(false);
            }}>
            <SettingsBrightnessOutlinedIcon />
            {darkMode ? "Light" : "Dark"} Mode
          </Item>
        </Wrapper>
      </Container>
    </>
  );
};

export default SmMenu;
